import React from 'react';
import { useMesPatrio } from '../hooks/useMesPatrio';
import './PlexarianLoader.css';

const PlexarianLoader = ({ message = 'Cargando…', size = '6em', className = '' }) => {
  const { enabled: mesPatrio } = useMesPatrio();
  return (
    <div
      className={`plexarian-loader${mesPatrio ? ' plexarian-loader--patrio' : ''} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <svg
        className="plexarian-loader__svg pl"
        width="240"
        height="240"
        viewBox="0 0 240 240"
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <circle
          className="pl__ring pl__ring--a"
          cx="120"
          cy="120"
          r="105"
          fill="none"
          strokeWidth="20"
          strokeDasharray="0 660"
          strokeDashoffset="-330"
          strokeLinecap="round"
        />
        <circle
          className="pl__ring pl__ring--b"
          cx="120"
          cy="120"
          r="35"
          fill="none"
          strokeWidth="20"
          strokeDasharray="0 220"
          strokeDashoffset="-110"
          strokeLinecap="round"
        />
        <circle
          className="pl__ring pl__ring--c"
          cx="85"
          cy="120"
          r="70"
          fill="none"
          strokeWidth="20"
          strokeDasharray="0 440"
          strokeLinecap="round"
        />
        <circle
          className="pl__ring pl__ring--d"
          cx="155"
          cy="120"
          r="70"
          fill="none"
          strokeWidth="20"
          strokeDasharray="0 440"
          strokeLinecap="round"
        />
      </svg>
      {message ? <p className="plexarian-loader__message">{message}</p> : null}
    </div>
  );
};

export const PlexarianLoaderOverlay = ({ message, initial = false }) => (
  <div
    className={`plexarian-loader-overlay${initial ? ' plexarian-loader-overlay--initial' : ''}`}
    aria-hidden={false}
  >
    <PlexarianLoader message={message} />
  </div>
);

/** Pantalla o sección completa mientras carga data pesada */
export const PlexarianLoaderScreen = ({
  message = 'Cargando…',
  size = '5em',
  minHeight = '320px',
  fullScreen = false,
  dark = false,
  className = '',
}) => (
  <div
    className={[
      'plexarian-loader-screen',
      fullScreen && 'plexarian-loader-screen--full',
      dark && 'plexarian-loader-screen--dark',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    style={fullScreen ? undefined : { minHeight }}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <PlexarianLoader message={message} size={size} />
  </div>
);

export default PlexarianLoader;
